import { CallNotesForm } from 'components'
// styles and assets
import styles from './CallNotes.module.scss'

const CallNotes = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <h2>Call Notes</h2>
      </div>

      <CallNotesForm />
    </div>
  )
}

export { CallNotes }
